import { CCOFranceCPSubFormValues } from "./france/CCOFranceCPSubForm";
import {
	CCOFranceECOCurtailmentType,
	CCOFrancePricingIndex,
	CCOFrancePricingMethod,
	FULL_FLEX_EC_TYPES,
} from "./france/constants";
import { CCOGermanyCPSubFormValues } from "./germany/CCOGermanyCPSubForm";

export function isDECCOGermanySubFormValues(
	values: CCOGermanyCPSubFormValues | CCOFranceCPSubFormValues,
	country: string
): values is CCOGermanyCPSubFormValues {
	return country === "DE";
}

export function isFRCCOFranceSubFormValues(
	values: CCOGermanyCPSubFormValues | CCOFranceCPSubFormValues,
	country: string
): values is CCOFranceCPSubFormValues {
	return country === "FR";
}

export function indexToCommodityFixingId(index: CCOFrancePricingIndex) {
	switch (index) {
		case CCOFrancePricingIndex.EpexSpotFRPowerQHDA:
			return 448;
		case CCOFrancePricingIndex.EpexSpotFRPowerHDA:
			return 132;
		default:
			throw new Error(`Unsupported index: ${index}`);
	}
}

export function mapFRCCOFormValuesToCurtailmentrequest(
	values: CCOFranceCPSubFormValues
) {
	const payload: Record<string, any> = {
		country_code: "FR",
		economical_curtailment: {
			curtailment_type: values.ec_curtailment_type,
		},
		redispatch: {
			compensate_spread: values.redispatch_compensate_spread,
		},
	};
	if (
		values.ec_curtailment_type !==
		CCOFranceECOCurtailmentType.NoEconomicalCurtailment
	) {
		payload.economical_curtailment.compensate_goo =
			values.ec_compensate_goo;
		payload.economical_curtailment.compensate_spread =
			values.ec_compensate_spread;
		payload.economical_curtailment.pricing_method =
			values.ec_pricing_method;
		switch (values.ec_pricing_method) {
			case CCOFrancePricingMethod.ContractPrice:
				break;
			case CCOFrancePricingMethod.Index:
				payload.economical_curtailment.commodity_index_id =
					indexToCommodityFixingId(
						values.ec_index as CCOFrancePricingIndex
					);
				break;
			case CCOFrancePricingMethod.InvoicePrice:
				payload.economical_curtailment.invoice_price =
					values.ec_invoice_price;
				break;
		}
	}
	if (values.enable_balancing_mechanism) {
		payload.balancing_mechanism = {
			bid_price: values.blm_bid_price,
			compensate_spread: values.blm_compensate_spread,
			curtailment_scenario: values.blm_curtailment_scenario,
			engie_share: values.blm_engie_share,
			pricing_method: values.blm_pricing_method,
		};
	}
	if (
		values.enable_full_flex &&
		FULL_FLEX_EC_TYPES.includes(values.ec_curtailment_type)
	) {
		payload.economical_curtailment.full_flex = {
			invoice_price: values.ff_invoice_price,
		};
	}
	return payload;
}

export function mapDECCOFormValuesToCurtailmentrequest(
	values: CCOGermanyCPSubFormValues
) {
	return {
		country_code: "DE",
		accounting_model: values.accounting_model,
		create_ch51: values.create_ch51,
		tr_settlement_model: values.tr_settlement_model,
	};
}

export function mapCCOFormValuesToCurtailmentrequest(
	values: CCOGermanyCPSubFormValues | CCOFranceCPSubFormValues,
	country: string
) {
	if (isDECCOGermanySubFormValues(values, country)) {
		return mapDECCOFormValuesToCurtailmentrequest(values);
	} else if (isFRCCOFranceSubFormValues(values, country)) {
		return mapFRCCOFormValuesToCurtailmentrequest(values);
	}
	throw new Error("Unsupported country code");
}
